import styled from "styled-components";

export const Container = styled.span`
  font-size: ${({ theme }) => theme.typography.Body.M["font-size"]}rem;
  line-height: ${({ theme }) => theme.typography.Body.M["line-height"]}rem;
  word-break: break-word;
  .paragraph {
    position: relative;
    margin-bottom: ${({ theme }) => theme.spacing["spacing-4"].value}rem;
    line-height: ${({ theme }) => theme.line_height["line-height-400"]}rem;
    & > span {
      font-size: ${({ theme }) => theme.typography.Body.L["font-size"]}rem;
      font-weight: ${({ theme }) =>
        theme.typography.Body.L["font-weight-regular"]};
      line-height: ${({ theme }) => theme.line_height["line-height-400"]}rem;
    }
  }

  .indent {
    --lexical-indent-base-value: ${({ theme }) =>
      theme.spacing["spacing-10"].value}rem;
  }
  .textBold {
    font-weight: bold;
  }
  .textItalic {
    font-style: italic;
  }
  .textUnderline {
    text-decoration: underline;
  }

  .ol2 {
    list-style-type: upper-alpha;
  }
  .ol3 {
    list-style-type: lower-alpha;
  }

  .ul {
    padding: ${({ theme }) => theme.spacing["spacing-none"].value}rem;
    margin-bottom: ${({ theme }) => theme.spacing["spacing-4"].value}rem;
    list-style-position: outside;
  }

  ol {
    padding: ${({ theme }) => theme.spacing["spacing-none"].value}rem;
    margin-bottom: ${({ theme }) => theme.spacing["spacing-4"].value}rem;
    list-style-position: outside;
  }

  .listItem {
    margin: ${({ theme }) => theme.spacing["spacing-none"].value}rem
      ${({ theme }) => theme.spacing["spacing-none"].value}rem
      ${({ theme }) => theme.spacing["spacing-none"].value}rem
      ${({ theme }) => theme.spacing["spacing-8"].value}rem !important;
    &::marker,
    span {
      font-size: ${({ theme }) => theme.typography.Body.L["font-size"]}rem;
      font-weight: ${({ theme }) =>
        theme.typography.Body.L["font-weight-regular"]};
      line-height: ${({ theme }) => theme.line_height["line-height-400"]}rem;
    }
  }

  .nestedListItem {
    list-style-type: none;
  }
  .nestedListItem:before,
  .nestedListItem:after {
    display: none;
  }

  h2 {
    margin-bottom: ${({ theme }) => theme.spacing["spacing-4"].value}rem;
    line-height: ${({ theme }) => theme.typography.Heading.M["line-height"]}rem;
    & > span {
      display: block;
      font-size: ${({ theme }) => theme.typography.Heading.M["font-size"]}rem;
      font-weight: ${({ theme }) =>
        theme.typography.Heading.M["font-weight-semibold"]};
      line-height: ${({ theme }) =>
        theme.typography.Heading.M["line-height"]}rem;
    }
  }
  h3 {
    margin-bottom: ${({ theme }) => theme.spacing["spacing-4"].value}rem;
    line-height: ${({ theme }) => theme.line_height["line-height-400"]}rem;
    & > span {
      font-size: ${({ theme }) => theme.typography.Heading.S["font-size"]}rem;
      font-weight: ${({ theme }) =>
        theme.typography.Heading.S["font-weight-semibold"]};
      line-height: ${({ theme }) => theme.line_height["line-height-400"]}rem;
    }
  }

  hr {
    margin-bottom: ${({ theme }) => theme.spacing["spacing-4"].value}rem;
    border: none;
    height: 1px;
    background: ${({ theme }) => theme.Color.border["ui-border-neutral"].value};
  }

  * {
    margin: ${({ theme }) => theme.spacing["spacing-none"].value}rem;
    vertical-align: middle;
  }
`;
